import React from "react";
import ArrowUpIcon from "mdi-react/ArrowUpBoldIcon";
import ArrowDownIcon from "mdi-react/ArrowDownBoldIcon";
import FlatIcon from "mdi-react/MinusIcon";
import { borderRadius, fontSize, fontWeight } from "@material-ui/system";

import {
  _isHouse,
  _formatPrice,
  _formatNumber,
} from "../../../../shared/helpers/utils";

export const formatDate = (tickItem, isWeekly) => {
  console.log(tickItem, isWeekly, "chintanTickItem");
  const date = new Date(tickItem);
  const month = date.getMonth() + 1;
  const day = String(date.getDate());
  const year = date.getFullYear();
  const monthName = date.toLocaleString("default", {
    month: "short",
    timeZone: "UTC",
  });

  if (isWeekly === "+7DAY") {
    return `${monthName} ${day}, ${year}`;
  } else if (isWeekly === "+1MONTH") {
    return `${monthName}, ${year}`;
  } else if (isWeekly === "+3MONTH") {
    let quarter;

    if (month >= 1 && month <= 3) {
      quarter = "Q1";
    } else if (month >= 4 && month <= 6) {
      quarter = "Q2";
    } else if (month >= 7 && month <= 9) {
      quarter = "Q3";
    } else {
      quarter = "Q4";
    }
    return `${quarter} ${year}`;
  } else if (isWeekly === "+1YEAR") {
    return `${year}`;
  } else {
    return `${month.toString().padStart(2, "0")}/${day}/${year}`;
  }
};

export const getPreviousMonthsData = (cardListViewData) => {
  if (
    !cardListViewData ||
    cardListViewData.length <= 0 ||
    !cardListViewData[cardListViewData.length - 1]
  )
    return [];
  return [
    cardListViewData[cardListViewData.length - 2],
    cardListViewData[cardListViewData.length - 1],
  ];
};

export const getPreviousYearData = (
  cardListViewData,
  currentDate,
  isWeekly
) => {
  if (!cardListViewData) return [];
  let oneYearBackDate = new Date(currentDate);

  if (isWeekly === "+7DAY") {
    oneYearBackDate.setDate(oneYearBackDate.getDate() - 52 * 7); // Subtract 52 weeks
    return cardListViewData.find((item) => {
      let itemDate = new Date(item.val);
      return itemDate.getTime() === oneYearBackDate.getTime();
    });
  } else {
    oneYearBackDate.setFullYear(oneYearBackDate.getFullYear() - 1); // one year back
    return cardListViewData.find((item) => {
      let itemDate = new Date(item.val);
      return itemDate.getTime() === oneYearBackDate.getTime();
    });
  }
};

export const getValueFromDotSeparatedKey = (jsonObject, keyString) => {
  if (!jsonObject || !keyString) return undefined;
  const keys = keyString.split(".");

  const getValue = (obj, keys) => {
    if (keys.length === 0) return obj;
    const [firstKey, ...restKeys] = keys;
    if (obj.hasOwnProperty(firstKey)) {
      return getValue(obj[firstKey], restKeys);
    } else {
      return undefined;
    }
  };

  return getValue(jsonObject, keys);
};
export const _sliceToLastNonZero = (arr, type) => {
  let lastIndex = arr.length - 1;
  while (
    lastIndex >= 0 &&
    (!arr[lastIndex][type.key] || arr[lastIndex][type.key].count === 0)
  ) {
    lastIndex--;
  }
  return arr.slice(0, lastIndex + 1);
};
export const getPercentage = (val1, val2) => {
  if (val1 && val2) {
    const percentageChange = ((val1 - val2) / val2) * 100;
    return `${percentageChange > 0 ? "+" : ""}${percentageChange.toFixed(2)}%`;
  } else {
    return "";
  }
};

export const neighbourhoodsGeoJSON = [
  {
    fontSize: 24,
    location: "Hudson Yards",
    geocode: "40.757066542278565, -73.9993304014206",
  },
  {
    fontSize: 24,
    location: "West Chelsea",
    geocode: "40.74829288975582, -74.00521516799927",
  },
  {
    fontSize: 24,
    location: "Roosevelt Island",
    geocode: "40.76147044864685, -73.95067512989044",
  },
  {
    fontSize: 24,
    location: "Turtle Bay",
    geocode: "40.75301527256151, -73.96992266178131",
  },
  {
    fontSize: 24,
    location: "Midtown South",
    geocode: "40.74991453334029, -73.98729264736176",
  },
  {
    fontSize: 24,
    location: "Midtown",
    geocode: "40.75957350129747, -73.97752940654755",
  },
  {
    fontSize: 24,
    location: "Murray Hill",
    geocode: "40.7478338717919, -73.97498667240143",
  },
  {
    fontSize: 24,
    location: "Chelsea",
    geocode: "40.74443200356971, -73.99752795696259",
  },
  {
    fontSize: 24,
    location: "Nomad",
    geocode: "40.74338774888568, -73.98717999458313",
  },
  {
    fontSize: 24,
    location: "Long Island City",
    geocode: "40.75456728560614, -73.9390879869461",
  },
  {
    fontSize: 24,
    location: "Hunter's Point",
    geocode: "40.74370866814324, -73.95182847976685",
  },
  {
    fontSize: 24,
    location: "Soho",
    geocode: "40.72396964010488, -74.00536000728607",
  },
  {
    fontSize: 24,
    location: "Tribeca",
    geocode: "40.71963558266516, -74.00881469249725",
  },
  {
    fontSize: 24,
    location: "West Village",
    geocode: "40.73612004706007, -74.00723218917847",
  },
  {
    fontSize: 24,
    location: "Greenpoint",
    geocode: "40.72823351537336, -73.9434814453125",
  },
  {
    fontSize: 24,
    location: "Stuyvesant Town",
    geocode: "40.73072216147551, -73.97674083709717",
  },
  {
    fontSize: 24,
    location: "Greenwich Village",
    geocode: "40.73196587483879, -73.99680376052856",
  },
  {
    fontSize: 24,
    location: "Kips Bay",
    geocode: "40.74048156125568, -73.9780068397522",
  },
  {
    fontSize: 24,
    location: "Gramercy Park",
    geocode: "40.73578297634862, -73.98426711559296",
  },
  {
    fontSize: 24,
    location: "Williamsburg",
    geocode: "40.71939166137594, -73.95921528339386",
  },
  {
    fontSize: 24,
    location: "Lower East Side",
    geocode: "40.71850133349672, -73.98427248001099",
  },
  {
    fontSize: 24,
    location: "East Village",
    geocode: "40.72657122058716, -73.98182094097137",
  },
  {
    fontSize: 24,
    location: "Flatiron",
    geocode: "40.73895341181816, -73.99162173271179",
  },
  {
    fontSize: 24,
    location: "Lenox Hill",
    geocode: "40.76518072692423, -73.96174728870392",
  },
  {
    fontSize: 24,
    location: "Astoria",
    geocode: "40.76594775260746, -73.92340779304504",
  },
  {
    fontSize: 24,
    location: "Sunnyside",
    geocode: "40.74416749275569, -73.92411589622498",
  },
  {
    fontSize: 24,
    location: "Jackson Heights",
    geocode: "40.75623313421981, -73.88520240783691",
  },
  {
    fontSize: 24,
    location: "Woodside",
    geocode: "40.75381464480567, -73.90441238880157",
  },
  {
    fontSize: 24,
    location: "Elmhurst",
    geocode: "40.741692624278755, -73.88349652290344",
  },
  {
    fontSize: 24,
    location: "Laurel Hill",
    geocode: "40.72932769361063, -73.92303228378296",
  },
  {
    fontSize: 24,
    location: "Blissville",
    geocode: "40.73355127752929, -73.93463015556335",
  },
  {
    fontSize: 24,
    location: "Maspeth",
    geocode: "40.727379153965714, -73.90506148338318",
  },
  {
    fontSize: 24,
    location: "Upper East Side",
    geocode: "40.77735387339487, -73.95708560943604",
  },
  {
    fontSize: 24,
    location: "Upper Manhattan",
    geocode: "40.81712958416742, -73.94792318344116",
  },
  {
    fontSize: 24,
    location: "Williamsburg and Greenpoint",
    geocode: "40.71886436667593, -73.94811630249023",
  },
  {
    fontSize: 24,
    location: "Northeast Brooklyn",
    geocode: "40.69161504040213, -73.93039226531982",
  },
  {
    fontSize: 24,
    location: "Southeast Brooklyn",
    geocode: "40.65741977033356, -73.89357089996338",
  },
  {
    fontSize: 24,
    location: "Flushing Meadows Corona Park",
    geocode: "40.73455662723063, -73.8335756111145",
  },
  {
    fontSize: 24,
    location: "Whitestone",
    geocode: "40.78517009331627, -73.81445646286011",
  },
  {
    fontSize: 24,
    location: "College Point",
    geocode: "40.78187166360195, -73.84192228317261",
  },
  {
    fontSize: 24,
    location: "East Elmhurst",
    geocode: "40.771407755386775, -73.87256383895874",
  },
  {
    fontSize: 24,
    location: "Forest Hills",
    geocode: "40.724004763964786, -73.84602069854736",
  },
  {
    fontSize: 24,
    location: "Middle Village",
    geocode: "40.72546862960313, -73.87546062469482",
  },
  {
    fontSize: 24,
    location: "Hollis",
    geocode: "40.7087336082316, -73.76521110534668",
  },
  {
    fontSize: 24,
    location: "Fresh Meadows",
    geocode: "40.7356638930863, -73.78096103668213",
  },
  {
    fontSize: 24,
    location: "Douglaston-Little Neck",
    geocode: "40.76358955538106, -73.73502016067505",
  },
  {
    fontSize: 24,
    location: "Queens Village",
    geocode: "40.72271840267422, -73.7407922744751",
  },
  {
    fontSize: 24,
    location: "Bayside",
    geocode: "40.76962375278711, -73.7874698638916",
  },
  {
    fontSize: 24,
    location: "Bay Terrace",
    geocode: "40.762680646322005, -73.79044914245605",
  },
  {
    fontSize: 24,
    location: "Bulls Head",
    geocode: "40.60702387579481, -74.16584193706512",
  },
  {
    fontSize: 24,
    location: "Meiers Corner",
    geocode: "40.612722450187945, -74.14129972457886",
  },
  {
    fontSize: 24,
    location: "Mariners Harbor",
    geocode: "40.63426896595929, -74.15427088737488",
  },
  {
    fontSize: 24,
    location: "Elm Park",
    geocode: "40.63110224890063, -74.14771556854248",
  },
  {
    fontSize: 24,
    location: "Westerleigh",
    geocode: "40.61946968315654, -74.14142847061157",
  },
  {
    fontSize: 24,
    location: "Graniteville",
    geocode: "40.61969355284781, -74.15752172470093",
  },
  {
    fontSize: 24,
    location: "Bloomfield",
    geocode: "40.61349493064394, -74.17438745498657",
  },
  {
    fontSize: 24,
    location: "Willowbrook",
    geocode: "40.60071485762391, -74.14416432380676",
  },
  {
    fontSize: 24,
    location: "Port Richmond",
    geocode: "40.63425258278755, -74.13098931312561",
  },
  {
    fontSize: 12,
    location: "Lincoln Square",
    geocode: "40.77449241842551, -73.98602664470673",
  },
  {
    fontSize: 12,
    location: "Clinton",
    geocode: "40.76595260087812, -73.99304866790771",
  },
  {
    fontSize: 24,
    location: "Old Place",
    geocode: "40.627348341824046, -74.17367935180664",
  },
  {
    fontSize: 12,
    location: "Sutton Place",
    geocode: "40.75739594898354, -73.96248757839203",
  },
  {
    fontSize: 24,
    location: "Arlington",
    geocode: "40.63835624057748, -74.17347550392151",
  },
  {
    fontSize: 24,
    location: "West New Brighton",
    geocode: "40.633828435910644, -74.10898447036743",
  },
  {
    fontSize: 24,
    location: "Randall Manor",
    geocode: "40.63933720197032, -74.10086274147034",
  },
  {
    fontSize: 24,
    location: "Silver Lake",
    geocode: "40.62464874219435, -74.09892082214355",
  },
  {
    fontSize: 24,
    location: "Sunnyside",
    geocode: "40.613406696759, -74.10732686519623",
  },
  {
    fontSize: 24,
    location: "Castleton Corners",
    geocode: "40.618614144439746, -74.11779820919037",
  },
  {
    fontSize: 24,
    location: "Manor Heights",
    geocode: "40.6016242606115, -74.12276029586792",
  },
  {
    fontSize: 24,
    location: "Todt Hill",
    geocode: "40.59564358078593, -74.10588383674622",
  },

  {
    fontSize: 12,
    location: "Fordham Heights",
    geocode: "40.8559869155434, -73.89934301376343",
  },
  {
    fontSize: 12,
    location: "Pelham Gardens",
    geocode: "40.86408492461834, -73.84179353713989",
  },
  {
    fontSize: 12,
    location: "Mount Hope",
    geocode: "40.84938943621037, -73.90708923339844",
  },
  {
    fontSize: 12,
    location: "Allerton",
    geocode: "40.867524780627974, -73.85786533355713",
  },
  {
    fontSize: 12,
    location: "Fordham University",
    geocode: "40.86242993854577, -73.88596415519714",
  },
  {
    fontSize: 12,
    location: "Fordham North",
    geocode: "40.866543625789475, -73.8934850692749",
  },
  {
    fontSize: 12,
    location: "Eastchester",
    geocode: "40.88382282879941, -73.82985234260559",
  },
  {
    fontSize: 12,
    location: "Olinville",
    geocode: "40.879158687219345, -73.86609435081482",
  },
  {
    fontSize: 12,
    location: "Morris Park",
    geocode: "40.85153986526066, -73.85129928588867",
  },
  {
    fontSize: 12,
    location: "Williamsbridge",
    geocode: "40.8794833276005, -73.85505437850952",
  },
  {
    fontSize: 12,
    location: "Kingsbridge Heights",
    geocode: "40.87409600462664, -73.8970148563385",
  },
  {
    fontSize: 12,
    location: "Bronx Zoo",
    geocode: "40.86174641259002, -73.87614727020264",
  },
  {
    fontSize: 12,
    location: "Norwood",
    geocode: "40.8777713110658, -73.87739181518555",
  },
  {
    fontSize: 12,
    location: "Bedford Park",
    geocode: "40.872839240001994, -73.88671517372131",
  },
  {
    fontSize: 12,
    location: "Edenwald",
    geocode: "40.88661320456035, -73.84080648422241",
  },
  {
    fontSize: 12,
    location: "Co-op City",
    geocode: "40.8695773671848, -73.82675170898438",
  },
  {
    fontSize: 12,
    location: "Bronxdale",
    geocode: "40.86412551484514, -73.86372327804565",
  },
  {
    fontSize: 12,
    location: "Tremont",
    geocode: "40.850614792138686, -73.89360308647156",
  },
  {
    fontSize: 12,
    location: "Belmont",
    geocode: "40.85638467177354, -73.88813138008118",
  },
  {
    fontSize: 12,
    location: "West Farms",
    geocode: "40.848375034426894, -73.88513803482056",
  },
  {
    fontSize: 12,
    location: "Van Nest",
    geocode: "40.84853734079964, -73.86504292488098",
  },
  {
    fontSize: 12,
    location: "Pelham Bay",
    geocode: "40.850825776002225, -73.83137583732605",
  },
  {
    fontSize: 12,
    location: "Van Cortland Park",
    geocode: "40.894778870892196, -73.88052463531494",
  },
  {
    fontSize: 12,
    location: "Pelham Bay Park",
    geocode: "40.867676077177194, -73.80931735038757",
  },
  {
    fontSize: 12,
    location: "Baychester",
    geocode: "40.87063235220354, -73.84160041809082",
  },
];

export const boroughsGeoJSON = [
  {
    location: "Bronx",
    geocode: "40.837048, -73.865433",
    fontSize: 24,
    offset: [0, -1.5],
  },
  {
    location: "Manhattan",
    geocode: "40.754932, -73.984016",
    fontSize: 24,
    offset: [0, -1.5],
  },
  {
    location: "Brooklyn",
    geocode: "40.650002, -73.949997",
    fontSize: 24,
    offset: [0, -1.5],
  },
  {
    location: "Queens",
    geocode: "40.742054, -73.769417",
    fontSize: 24,
    offset: [-3, 3],
  },
  {
    location: "Staten Island",
    geocode: "40.579021, -74.151535",
    fontSize: 24,
    offset: [0, -1.5],
  },
];

export const formatDateRange = (startDate, endDate, singleDate = null) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize today's date

  if (singleDate) {
    const date = new Date(singleDate); // Parse ISO string (treated as UTC)
    date.setUTCHours(0, 0, 0, 0); // Set to midnight in UTC to avoid DST/ST issues
    return formatShortDate(date);
  }

  startDate = new Date(startDate);
  endDate = new Date(endDate);

  // Normalize start and end dates
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  // Helper functions
  function isSameDay(d1, d2) {
    return d1.getTime() === d2.getTime();
  }

  function getWeekStartDate(date) {
    const dayOfWeek = date.getDay(); // 0 (Sunday) to 6 (Saturday)
    const weekStart = new Date(date);
    weekStart.setDate(weekStart.getDate() - dayOfWeek);
    weekStart.setHours(0, 0, 0, 0);
    return weekStart;
  }

  function getWeekEndDate(date) {
    const weekEnd = getWeekStartDate(date);
    weekEnd.setDate(weekEnd.getDate() + 6);
    return weekEnd;
  }

  function getQuarterStartDate(date) {
    const quarter = Math.floor(date.getMonth() / 3);
    return new Date(date.getFullYear(), quarter * 3, 1);
  }

  function getQuarterEndDate(date) {
    const quarter = Math.floor(date.getMonth() / 3);
    return new Date(date.getFullYear(), quarter * 3 + 3, 0);
  }

  function getMonthEndDate(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  function formatDate(date, options) {
    return date.toLocaleDateString(undefined, options);
  }

  function formatShortDate(date) {
    const month = date.getUTCMonth() + 1; // Get month in UTC
    const day = date.getUTCDate(); // Get day in UTC
    const year = date.getUTCFullYear().toString().slice(-2); // Last two digits of year
    return `${month}/${day}/${year}`;
  }

  // Determine periods
  const currentWeekStart = getWeekStartDate(today);
  const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
  const currentQuarterStart = getQuarterStartDate(today);
  const currentYearStart = new Date(today.getFullYear(), 0, 1);

  // Week to Date
  if (isSameDay(startDate, currentWeekStart) && isSameDay(endDate, today)) {
    return `WTD ${today.getFullYear()}`;
  }

  // Month to Date
  if (isSameDay(startDate, currentMonthStart) && isSameDay(endDate, today)) {
    return `MTD ${today.getFullYear()}`;
  }

  // Quarter to Date
  if (isSameDay(startDate, currentQuarterStart) && isSameDay(endDate, today)) {
    return `QTD ${today.getFullYear()}`;
  }

  // Year to Date
  if (isSameDay(startDate, currentYearStart) && isSameDay(endDate, today)) {
    return `YTD ${today.getFullYear()}`;
  }

  // Previous Weeks
  const weekStart = getWeekStartDate(startDate);
  const weekEnd = getWeekEndDate(startDate);
  if (
    isSameDay(startDate, weekStart) &&
    endDate >= startDate &&
    isSameDay(endDate, weekEnd)
  ) {
    return `${formatDate(weekStart, {
      month: "short",
      day: "numeric",
    })} Wk ${startDate.getFullYear()}`;
  }

  // Week to Date (Any Week)
  if (
    isSameDay(startDate, weekStart) &&
    endDate >= startDate &&
    endDate < weekEnd
  ) {
    return `${formatDate(weekStart, {
      month: "short",
      day: "numeric",
    })} WTD ${startDate.getFullYear()}`;
  }

  // Previous Months to Date
  const monthStart = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
  const monthEnd = getMonthEndDate(startDate);
  if (
    isSameDay(startDate, monthStart) &&
    endDate >= startDate &&
    endDate < monthEnd
  ) {
    const monthName = formatDate(startDate, { month: "short" });
    return `${monthName} MTD ${startDate.getFullYear()}`;
  }

  // Full Month
  if (isSameDay(startDate, monthStart) && isSameDay(endDate, monthEnd)) {
    const monthName = formatDate(startDate, { month: "short" });
    return `${monthName} ${startDate.getFullYear()}`;
  }

  // Previous Quarters to Date
  const quarterStart = getQuarterStartDate(startDate);
  const quarterEnd = getQuarterEndDate(startDate);
  if (
    isSameDay(startDate, quarterStart) &&
    endDate >= startDate &&
    endDate < quarterEnd
  ) {
    const quarterNumber = Math.floor(startDate.getMonth() / 3) + 1;
    return `Q${quarterNumber} QTD ${startDate.getFullYear()}`;
  }

  // Full Quarter
  if (isSameDay(startDate, quarterStart) && isSameDay(endDate, quarterEnd)) {
    const quarterNumber = Math.floor(startDate.getMonth() / 3) + 1;
    return `Q${quarterNumber} ${startDate.getFullYear()}`;
  }

  // Previous Years to Date
  const yearStart = new Date(startDate.getFullYear(), 0, 1);
  const yearEnd = new Date(startDate.getFullYear(), 11, 31);
  if (
    isSameDay(startDate, yearStart) &&
    endDate >= startDate &&
    endDate < yearEnd
  ) {
    return `YTD ${startDate.getFullYear()}`;
  }

  // Full Year
  if (isSameDay(startDate, yearStart) && isSameDay(endDate, yearEnd)) {
    return `${startDate.getFullYear()}`;
  }

  // Default date range format
  const startStr = formatShortDate(startDate);
  const endStr = formatShortDate(endDate);

  return `${startStr} - ${endStr}`;
};

export const validateNestedData = (obj, path) => {
  const keys = path.split(".");
  let current = obj;

  for (let key of keys) {
    if (current[key] === undefined) {
      return false;
    }
    current = current[key];
  }

  return true;
};

const calculatePercentageChange = (
  newValue,
  oldValue,
  reverseColors = false
) => {
  if (oldValue === 0) {
    return <span>--</span>;
  }

  const percentageChange = ((newValue - oldValue) / oldValue) * 100;
  const roundedChange = Math.round(percentageChange * 10) / 10; // Round to nearest 1 decimal place

  // Determine the direction and set icon and color
  let icon = "";
  let color = "";

  if (roundedChange > 0) {
    icon = "up"; // Up arrow icon
    color = reverseColors ? "stat-down" : "stat-up"; // Reversed color if reverseColors is true
  } else if (roundedChange < 0) {
    icon = "down"; // Down arrow icon
    color = reverseColors ? "stat-up" : "stat-down"; // Reversed color if reverseColors is true
  } else {
    icon = "flat"; // No change icon
    color = "stat-flat"; // Neutral color for no change
  }

  return (
    <span className={color}>
      {icon == "up" ? (
        <ArrowUpIcon />
      ) : icon == "down" ? (
        <ArrowDownIcon />
      ) : (
        <FlatIcon />
      )}{" "}
      {Math.abs(roundedChange)}%
    </span>
  );
};

export const previousYearPeriod = (dateOptions) => {
  if (dateOptions.startDate && dateOptions.endDate) {
    const previousYearStartDate = dateOptions.startDate
      .clone()
      .subtract(1, "years");
    const previousYearEndDate = dateOptions.endDate
      .clone()
      .subtract(1, "years");
    const label = `[${previousYearStartDate.toISOString()} TO ${previousYearEndDate.toISOString()}]`;
    return label;
  } else return `[]`;
};

export const isFullMonthPeriod = (start, end) => {
  const isStartOfMonth = start.date() === 1;
  const isEndOfMonth = end.date() === end.daysInMonth();
  return isStartOfMonth && isEndOfMonth;
};
export const generatePeriodNames = (dateOptions) => {
  const { startDate, endDate, previousStartDate, previousEndDate } =
    dateOptions;
  const currentPeriod = formatDateRange(startDate, endDate);

  const priorPeriod = formatDateRange(previousStartDate, previousEndDate);

  const priorYearPeriod = formatDateRange(previousStartDate, previousEndDate);

  return {
    currentPeriod,
    priorPeriod,
    priorYearPeriod,
  };
};
export const getCurrentPeriod = (dateOptions) => {
  const { startDate, endDate } = dateOptions;
  if (startDate && endDate) {
    return `[${startDate.toISOString()} TO ${endDate.toISOString()}]`;
  } else return "";
};
export const getPriorPeriod = (dateOptions) => {
  const { previousStartDate, previousEndDate } = dateOptions;
  if (previousEndDate && previousStartDate) {
    return `[${previousStartDate.toISOString()} TO ${previousEndDate.toISOString()}]`;
  } else return "";
};

export const getRangeEnd = (dateOptions) => {
  const { endDate } = dateOptions;
  if (!endDate) {
    return "";
  }
  return endDate.toISOString();
};
export const rangeStart = (dateString) => {
  const utcDate = new Date(dateString);

  // Create a new date object in the local timezone
  const localDate = new Date(utcDate.getTime());

  // Check if DST is in effect for the given date
  const isDST = () => {
    const january = new Date(localDate.getFullYear(), 0, 1).getTimezoneOffset();
    const july = new Date(localDate.getFullYear(), 6, 1).getTimezoneOffset();
    return localDate.getTimezoneOffset() < Math.max(january, july);
  };

  // Adjust the date based on DST
  if (!isDST()) {
    localDate.setHours(localDate.getHours() + 1);
  }

  return localDate.toISOString();
};

// Usage
export const getRangeStart = rangeStart("2018-01-01T04:00:00Z");

export const percentageChange = (newValue, oldValue) => {
  if (oldValue === 0) return "--";
  const percentageChange = ((newValue - oldValue) / oldValue) * 100;
  const roundedChange = Math.round(percentageChange * 10) / 10;

  return roundedChange;
};

export const prepareResForAI = (
  obj,
  keysToRemove = [
    "chart",
    "contract_signed..ppsf",
    "contract_signed..med_price",
    "contract_signed..price_change",
    "contract_signed..sum_price",
  ]
) => {
  if (!Array.isArray(keysToRemove)) {
    throw new Error("keysToRemove must be an array");
  }

  // Helper function to remove key if matched by dot notation (direct parent-child relationship)
  const deleteKeyFromObject = (obj, keyPath) => {
    const keys = keyPath.split(".");
    let currentObj = obj;

    for (let i = 0; i < keys.length - 1; i++) {
      if (
        typeof currentObj[keys[i]] === "object" &&
        currentObj[keys[i]] !== null
      ) {
        currentObj = currentObj[keys[i]];
      } else {
        return; // If path doesn't exist, exit early
      }
    }

    const finalKey = keys[keys.length - 1];
    if (finalKey in currentObj) {
      delete currentObj[finalKey];
    }
  };

  // Helper function to remove key if matched by double dot notation (parent-child anywhere in hierarchy)
  const deleteKeyByDoubleDot = (obj, parentKey, childKey) => {
    if (typeof obj !== "object" || obj === null) return;

    // Check for parentKey at current level
    for (const key in obj) {
      if (key === parentKey) {
        // If parentKey exists, check for childKey anywhere in its nested structure
        checkForChildKey(obj[key], childKey);
      }

      // Recursively check for parentKey and childKey deeper in the structure
      if (typeof obj[key] === "object") {
        deleteKeyByDoubleDot(obj[key], parentKey, childKey);
      }
    }
  };

  // Helper function to recursively check and delete the childKey if found
  const checkForChildKey = (obj, childKey) => {
    if (typeof obj !== "object" || obj === null) return;

    for (const key in obj) {
      if (key === childKey) {
        delete obj[key];
      }

      if (typeof obj[key] === "object") {
        checkForChildKey(obj[key], childKey); // Recursively search deeper levels
      }
    }
  };

  // Recursive function to iterate through the object and remove matching keys
  const recursiveRemoveKeys = (obj) => {
    if (Array.isArray(obj)) {
      // If the object is an array, iterate over its elements
      for (let i = 0; i < obj.length; i++) {
        if (typeof obj[i] === "object" && obj[i] !== null) {
          obj[i] = recursiveRemoveKeys(obj[i]);
        }
      }
      return obj.filter((item) => item !== null); // Remove any null values (deleted nodes)
    } else if (typeof obj === "object" && obj !== null) {
      // If the object is not an array, iterate over its keys
      for (const key in obj) {
        // Check for both dot notation and non-dot notation matches
        for (const keyToRemove of keysToRemove) {
          if (keyToRemove.includes("..")) {
            const [parentKey, childKey] = keyToRemove.split("..");
            deleteKeyByDoubleDot(obj, parentKey, childKey); // Handle double dot notation
          } else if (keyToRemove.includes(".")) {
            deleteKeyFromObject(obj, keyToRemove); // Handle dot notation
          } else if (key === keyToRemove) {
            delete obj[key]; // Remove matching key at any level
          }
        }

        // Recursively check nested objects
        if (typeof obj[key] === "object" && obj[key] !== null) {
          obj[key] = recursiveRemoveKeys(obj[key]);
        }
      }
      return obj;
    } else {
      // Return other types of values (primitives) as they are
      return obj;
    }
  };

  return recursiveRemoveKeys(obj);
};

export const themes = {
  custom: {
    name: "Custom",
    primaryColor: "#9600BF",
    opacityPrimaryColor:"rgba(150, 0, 191, 0.1)",
    backgroundColor: "#FFF",
    headerBackgroundColor: "#171F26",
    headerTextColor: "#FFF",
    headerSubtextColor: "#DBE0E8",
    sectionHeaderColor: "#333",
    sectionSubtextColor: "#888",
    tableBorderColor: "#F5F7FA",
    footerTextColor: "#999",
    statColor: "#555",
    textColor: "#333",
    statUp: "#0fd676",
    statDown: "#ff206e",
    reportlayoutSubHeadingText: "#fff",
    // opacityBackground:  'rgba(150,0,191,0.3)',
    opacityElementColor: "#333",
    switchBackgroundColor: "#e4e1d7",
    buildingViewBackGround:"#171F26",
    buildingViewTextColor:"#FFF",
    coverBackgroundColor:"#9600BF",
    coverTextColor:"#FFF"

  },
  default: {
    name: "Slate",
    primaryColor: "#434C5B",
    opacityPrimaryColor:"rgba(67, 76, 91, 0.1)",
    backgroundColor: "#FFFDF8",
    headerBackgroundColor: "#434C5B",
    headerTextColor: "#FFF",
    headerSubtextColor: "#DBE0E8",
    sectionHeaderColor: "#333",
    sectionSubtextColor: "#888",
    tableBorderColor: "#F5F7FA",
    footerTextColor: "#999",
    statColor: "#555",
    textColor: "#333",
    statUp: "#95E06C",
    statDown: "#FF3C38",
    reportlayoutSubHeadingText: "#434C5B",
    opacityBackground: "rgba(0,0,0,0.3)",
    opacityElementColor: "#333",
    switchBackgroundColor: "#e4e1d7",
    postCardImageBackGround: "#f1ebff",
    buildingViewBackGround:"#434C5B",
    buildingViewTextColor:"#FFFDF8",
    coverBackgroundColor:"#FFFDF8",
    coverTextColor:"#333"

  },
  cinnabar: {
    name: "Cinnabar",
    primaryColor: "#E55934",
    opacityPrimaryColor:"rgba(229, 89, 52, 0.1)",
    backgroundColor: "#FFF",
    headerBackgroundColor: "#E55934",
    headerTextColor: "#FFF",
    headerSubtextColor: "#DBE0E8",
    sectionHeaderColor: "#333",
    sectionSubtextColor: "#888",
    tableBorderColor: "#F5F7FA",
    footerTextColor: "#999",
    statColor: "#555",
    textColor: "#333",
    statUp: "#E55934",
    statDown: "#E55934",
    reportlayoutSubHeadingText: "#fff",
    opacityBackground: "rgba(229, 89, 52, 0.3)",
    opacityElementColor: "#333",
    switchBackgroundColor: "#e4e1d7",
    buildingViewBackGround:"#E55934",
    buildingViewTextColor:"#FFFDF8",
    coverBackgroundColor:"#FFF",
    coverTextColor:"#E55934"

  },
  xanthous: {
    name: "Xanthous",
    primaryColor: "#E6AF2E",
    opacityPrimaryColor:"rgba(230, 175, 46, 0.1)",
    backgroundColor: "#FFF",
    headerBackgroundColor: "#E6AF2E",
    headerTextColor: "#FFF",
    headerSubtextColor: "#DBE0E8",
    sectionHeaderColor: "#333",
    sectionSubtextColor: "#888",
    tableBorderColor: "#F5F7FA",
    footerTextColor: "#999",
    statColor: "#555",
    textColor: "#333",
    statUp: "#E6AF2E",
    statDown: "#E6AF2E",
    opacityBackground: "rgba(230, 175, 46, 0.3)",
    reportlayoutSubHeadingText: "#fff",
    opacityElementColor: "#333",
    switchBackgroundColor: "#e4e1d7",
    buildingViewBackGround:"#E6AF2E",
    buildingViewTextColor:"#FFFDF8",
    coverBackgroundColor:"#FFF",
    coverTextColor:"#E6AF2E"

  },
  dark: {
    name: "Dark",
    // primaryColor: "#9600BF",
    primaryColor: "#f8ffef",
    backgroundColor: "#333",
    opacityPrimaryColor:"rgba(248, 255, 239, 0.1)",
    headerBackgroundColor: "#9600BF",
    headerTextColor: "#FFF",
    headerSubtextColor: "#FFF",
    sectionHeaderColor: "#FFF",
    sectionSubtextColor: "#BBBBBB",
    tableBorderColor: "#444",
    footerTextColor: "#CCC",
    statColor: "#EEE",
    textColor: "#FFF",
    statUp: "#FFF",
    statDown: "#FFF",
    logoFilter: "brightness(0) invert(1)",
    reportlayoutSubHeadingText: "#f8ffef",
    opacityBackground: "rgba(0,0,0,0.3)",
    opacityElementColor: "#f8ffef",
    switchBackgroundColor: "rgba(0,0,0,0.3)",
    postCardImageBackGround: "#333",
    buildingViewBackGround:"#f8ffef",
    buildingViewTextColor:"#333",
    coverBackgroundColor:"#333",
    coverTextColor:"#FFF"

  },
  black: {
    name: "Black",
    primaryColor: "#000",
    opacityPrimaryColor:"rgba(0, 0, 0, 0.1)",
    backgroundColor: "#FFF",
    headerBackgroundColor: "#000",
    headerTextColor: "#FFF",
    headerSubtextColor: "#DBE0E8",
    sectionHeaderColor: "#333",
    sectionSubtextColor: "#888",
    tableBorderColor: "#F5F7FA",
    footerTextColor: "#999",
    statColor: "#555",
    textColor: "#333",
    statUp: "#000",
    statDown: "#000",
    reportlayoutSubHeadingText: "#000",
    opacityBackground: "rgba(0,0,0,0.3)",
    opacityElementColor: "#333",
    switchBackgroundColor: "#fff",
    switchBackgroundColor: "#e4e1d7",
    postCardImageBackGround: "#f1ebff",
    buildingViewBackGround:"#000",
    buildingViewTextColor:"#FFF",
    coverBackgroundColor:"#FFF",
    coverTextColor:"#000"
    

  },
  lapis: {
    name: "Lapis",
    primaryColor: "#33658A",
    opacityPrimaryColor:"rgba(51, 101, 138, 0.1)",
    backgroundColor: "#FFF",
    headerBackgroundColor: "#33658A",
    headerTextColor: "#FFF",
    headerSubtextColor: "#DBE0E8",
    sectionHeaderColor: "#333",
    sectionSubtextColor: "#888",
    tableBorderColor: "#F5F7FA",
    footerTextColor: "#999",
    statColor: "#555",
    textColor: "#333",
    statUp: "#33658A",
    statDown: "#33658A",
    opacityBackground: "rgb(51, 101, 138, 0.3)",
    reportlayoutSubHeadingText: "#fff",
    opacityElementColor: "#333",
    switchBackgroundColor: "#fff",
    switchBackgroundColor: "#e4e1d7",
    postCardImageBackGround: "#f1ebff",
    buildingViewBackGround:"#33658A",
    buildingViewTextColor:"#FFF",
    coverBackgroundColor:"#FFF",
    coverTextColor:"#33658A"

  },

  viridian: {
    name: "Viridian",
    primaryColor: "#5B9279",
    opacityPrimaryColor:"rgba(91, 146, 121, 0.1)",
    backgroundColor: "#FFF",
    headerBackgroundColor: "#5B9279",
    headerTextColor: "#FFF",
    headerSubtextColor: "#DBE0E8",
    sectionHeaderColor: "#333",
    sectionSubtextColor: "#888",
    tableBorderColor: "#F5F7FA",
    footerTextColor: "#999",
    statColor: "#555",
    textColor: "#333",
    statUp: "#5B9279",
    statDown: "#5B9279",
    reportlayoutSubHeadingText: "#fff",
    opacityBackground: "rgba(91, 146, 121, 0.3)",
    opacityElementColor: "#333",
    switchBackgroundColor: "#e4e1d7",
    postCardImageBackGround: "#f1ebff",
    buildingViewBackGround:"#5B9279",
    buildingViewTextColor:"#FFF",
    coverBackgroundColor:"#FFF",
    coverTextColor:"#5B9279"

  },
};

export const customStyles = {
  style1: {
    id: "default",
    name: "Bold",
    backgroundColor: "#434C5B",
    color: "#fff",
  },
  style2: {
    id: "style2",
    name: "Elegent",
    backgroundColor: "#FFFDF8",
    color: "#333",
    font: "Merriweather",
    bodyFont: "Playfair Display",
    fontColor: "#333",
  },
  // style3: {
  //   id:"style3",
  //   name:"Coming",
  //   backgroundColor:"#FFFDF8",
  //   color:"#333",
  //   font:"Merriweather",
  //   bodyFont:'Playfair Display',
  //   fontColor:"#333"
  // },
  // style4: {
  //   id:"style4",
  //   name:"Coming",
  //   backgroundColor:"#FFFDF8",
  //   color:"#333",
  //   font:"Merriweather",
  //   bodyFont:'Playfair Display',
  //   fontColor:"#333"
  // },
  // style3: {
  //   id:"style3",
  //   name:"Style 3",
  //   backgroundColor:"#333",
  //   color:"#fff"
  // },
  // style4: {
  //   id:"style4",
  //   name:"Style 4",
  //   backgroundColor:"#333",
  //   color:"#fff"
  // },
};

export const findStyles = (key) => key && customStyles[key];

export const hexToRgb = (hex) => {
  // Remove the hash symbol if present
  hex = hex.replace("#", "");

  // Convert 3-digit hex to 6-digit hex
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return { r, g, b };
};

export const getLuminance = ({ r, g, b }) => {
  // Normalize the RGB values by dividing by 255
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });

  // Calculate the luminance using the formula
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

export const isColorDark = (hexColor) => {
  const rgb = hexToRgb(hexColor);
  const luminance = getLuminance(rgb);

  // A luminance threshold to determine if the color is dark or light
  return luminance < 0.3;
};

export const filterAIData = (data) => {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      console.error('Invalid JSON string:', e);
      return null;
    }
  }
  // Define keys to keep specifically for each category type
  const keysForContractSigned = ["count", "dom", "ppsf"];
  const keysForRecordedSold = ["med_price", "ppsf"];

  // Define general keys allowed globally if they appear
  const generalKeys = ["inventory"];

  // Function to round numeric values
  function roundValues(obj) {
    const rounded = {};
    for (let key in obj) {
      rounded[key] =
        typeof obj[key] === "number" ? Math.round(obj[key]) : obj[key];
    }
    return rounded;
  }

  // Function to filter each period, including general keys if present
  function filterPeriod(period, keysToKeep) {
    const filtered = {};
    if (!period) return filtered; // Return empty object if period is undefined
    for (let key of keysToKeep) {
      if (period[key] !== undefined) {
        filtered[key] = period[key];
      }
    }
    return roundValues(filtered);
  }

  // Main function to filter each category type
  function filterCategory(category, keysToKeep) {
    return {
      current_period:
        category && category.current_period
          ? filterPeriod(category.current_period, keysToKeep)
          : {},
      prior_year_period:
        category && category.prior_year_period
          ? filterPeriod(category.prior_year_period, keysToKeep)
          : {},
    };
  }

  // Iterate through the root-level categories dynamically
  const result = {};
  for (let key in data) {
    if (generalKeys.includes(key)) {
      // If it's a general key, include it as is
      result[key] = data[key];
    } else if (key !== "count" && typeof data[key] === "object") {
      result[key] = {
        contract_signed: data[key].contract_signed
          ? filterCategory(data[key].contract_signed, keysForContractSigned)
          : {},
        recorded_sold: data[key].recorded_sold
          ? filterCategory(data[key].recorded_sold, keysForRecordedSold)
          : {},
      };
    }
  }

  return result;
};
export function calculateAverages(data, priceField, sqFtField) {
    if (!Array.isArray(data) || data.length === 0) {
        return { avgPrice: 0, avgPPSF: 0 };
    }

    let totalPrice = 0;
    let totalPriceCount = 0;
    let totalSqFt = 0;
    let totalPriceForSqFt = 0;

    data.forEach(item => {
        const price = parseFloat(item[priceField]);
        const sqFt = parseFloat(item[sqFtField]);

        if (!isNaN(price) && price > 0) {
            totalPrice += price;
            totalPriceCount++;

            if (!isNaN(sqFt) && sqFt > 0) {
                totalPriceForSqFt += price;
                totalSqFt += sqFt;
            }
        }
    });

    return {
        avgPrice: totalPriceCount > 0 ? totalPrice / totalPriceCount : 0,
        avgPPSF: totalSqFt > 0 ? totalPriceForSqFt / totalSqFt : 0
    };
}

export const getDerived = (theReportData, activeCompsOverride, soldCompsOverride) => {
  
  if (theReportData) {
   
  
    let subjectProperty = theReportData.compSettings.propertyDetails.property;
    subjectProperty = Object.assign(subjectProperty, theReportData.compSettings.propertyDetails);
    subjectProperty["suggestedPrice"] =
      theReportData &&
      theReportData.compResponse &&
      theReportData.compResponse.suggestedPrice
        ? theReportData.compResponse.suggestedPrice
        : 0;
    subjectProperty["suggestedPricePPSF"] = subjectProperty["sq_ft"] > 1 ?
      subjectProperty["suggestedPrice"] / subjectProperty["sq_ft"] : false;
    subjectProperty["suggestedPriceLow"] = subjectProperty["suggestedPrice"] * 0.9;
    subjectProperty["suggestedPriceHigh"] = subjectProperty["suggestedPrice"] * 1.1;
    let avgDOM = theReportData.compResponse.avgDOM ? theReportData.compResponse.avgDOM : null;
    let avgDiscount = theReportData.compResponse.avgDiscount
      ? (Number.parseFloat(theReportData.compResponse.avgDiscount).toFixed(1)) * -1
      : null;
    let activeComps = activeCompsOverride ? activeCompsOverride : theReportData.compResponse.comps.active.slice(0, 3);
    let avgActiveComps = calculateAverages(activeComps, "last_listed_sale_price_all", "sq_ft");
    let soldComps = soldCompsOverride ? soldCompsOverride : theReportData.compResponse.comps.sold.slice(0, 3);
    let avgSoldComps = calculateAverages(soldComps, "last_sold_price", "sq_ft");
    let currentCashBuyers = theReportData.compResponse.currentCashBuyers;
    let currentFinancedBuyers = theReportData.compResponse.currentFinancedBuyers;
    let percentCashBuyers =
      currentCashBuyers.count && currentFinancedBuyers.count
        ? Number.parseFloat(
            (currentCashBuyers.count /
              (currentCashBuyers.count + currentFinancedBuyers.count)) *
              100
          ).toFixed(0)
        : "--";
    let percentFinanced = currentFinancedBuyers.avg_financed
      ? Number.parseFloat(100 - currentFinancedBuyers.avg_financed).toFixed(0)
      : "--";
    let activityResponse = theReportData.compResponse.activityResponse
      ? theReportData.compResponse.activityResponse
      : null;
      
    const {buildingRes} = theReportData;
    
    const isCoop =["coop"].indexOf(buildingRes.ownership_type)>=0;
  
    return {
      subjectProperty,
      avgDOM,
      avgDiscount,
      activeComps,
      avgActiveComps,
      soldComps,
      avgSoldComps,
      currentCashBuyers,
      currentFinancedBuyers,
      percentCashBuyers,
      percentFinanced,
      activityResponse,
      isCoop
    };
  }
}


export function formatPropertyData(input, isSubject) {
  if (!input) return false;
console.log(input)
  const isActive = input.current_status === "active";

  const price = isSubject
    ? _formatPrice(input.suggestedPrice)
    : isActive
      ? input.last_listed_sale_price_all > 0 ? _formatPrice(input.last_listed_sale_price_all) : "N/A"
      : input.last_sold_price > 0 ? _formatPrice(input.last_sold_price) : "N/A";

  const priceType = isSubject
    ? "Suggested Price"
    : isActive
      ? "Asking Price"
      : "Sold Price";

  const psfValue = isSubject
    ? input.suggestedPricePPSF
    : isActive
      ? input["div(last_listed_sale_price_all, sq_ft)"]
      : input["div(last_sold_price, sq_ft)"];

  const psf = psfValue > 0 && input.sq_ft && input.sq_ft > 1 ? "$" + _formatNumber(psfValue) : "N/A";

  const psfType = isSubject
    ? isActive ? "Suggested List PSF" : "Suggested PSF"
    : isActive ? "Asking PSF" : "Sold PSF";

  const daysOnMarket = !isSubject && isActive && input.last_listed_sale_date_all > 0
    ? Math.round((Date.now() / 1000 - input.last_listed_sale_date_all) / (60 * 60 * 24))
    : "N/A";

  const date = !isSubject
    ? isActive && input.last_listed_sale_date_all > 0
      ? new Date(
          Math.max(input.last_listed_sale_modified_date_all || 0, input.last_listed_sale_date_all) * 1000
        ).toLocaleDateString("en-US", {
          month: "numeric",
          day: "numeric",
          year: "numeric"
        })
      : !isActive && input.last_sold_date > 0
        ? new Date(input.last_sold_date * 1000).toLocaleDateString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric"
          })
        : false
    : false;


  return {
    id: input.id || "comp1",
    isSubject: isSubject,
    currentStatus: isActive ? "On the Market" : ["in contract", "pending"].indexOf(input.current_status)>=0 ? "In Contract" : "Off Market",
    img: "https://newsapi.marketproof.com/buildings/pictures/" + input.building,
    title: input.display_full_street_address + (input.address_2_normalized ? " - " + input.address_2_normalized.toUpperCase() : ""),
    location:
      (input.neighborhood && input.neighborhood.length > 0
        ? input.neighborhood[0].charAt(0).toUpperCase() + input.neighborhood[0].slice(1)
        : "") +
      (input.borough ? ", " + input.borough.charAt(0).toUpperCase() + input.borough.slice(1) : ""),
    type: _isHouse(input) && input.ownership_type === "rental"
      ? "House/Townhouse"
      : input.ownership_type
        ? input.ownership_type.charAt(0).toUpperCase() + input.ownership_type.slice(1)
        : "Unknown",
    yearBuilt: input.year_built > 0 ? input.year_built : "N/A",
    bedsBaths: input.bedrooms > -1 ? input.bedrooms + " Bed / " + input.baths + " Bath" : "--",
    size: input.sq_ft && input.sq_ft > 1 ? input.sq_ft.toLocaleString() + " SF" : "N/A",
    price: price,
    priceType: priceType,
    psf: psf,
    psfType: psfType,
    daysOnMarket: isSubject ? null : daysOnMarket,
    daysOnMarketHeading: isSubject ? "Expected DOM" : "Days on Market",
    date: date,
    tag: isSubject ? "SUBJECT" : "COMP",
    buildingAmenities: input.building_features || [],
    unitFeature: input.property_features || [],
    floor: input.floor || null,
    distance: input["geodist()"] != null ? `${(input["geodist()"] * 0.621371).toFixed(2)} mi` : null

  };
}
export const roundUpToNearest = (number, roundFactor = 25000) => {
  if (number > 99000000) {
    // Round up to the nearest million (i.e. remove any thousands digits)
    return Math.ceil(number / 1000000) * 1000000;
  }
  // Otherwise, round up to the nearest roundFactor (default is 25,000)
  const rounded = Math.ceil(number / roundFactor) * roundFactor;
  return rounded > number ? rounded : number;
}
export const toggleHttps = (url, shouldAdd) => {
  if (typeof url !== 'string') return '';

  const hasProtocol = /^https?:\/\//i.test(url);

  if (shouldAdd) {
    return hasProtocol ? url : 'https://' + url;
  } else {
    return hasProtocol ? url.replace(/^https?:\/\//i, '') : url;
  }
}